//This checks if a.) the innerWidth is tablet size or smaller, and b.) if the device is touch screen
module.exports = { isMobile: window.innerWidth <= 768 && navigator.maxTouchPoints > 0 };